import React, { useState } from 'react';
import IncomeCalculator from './IncomeCalculator';
import './index.css';
import { useTranslation } from 'react-i18next';

function App() {
    const { i18n } = useTranslation();
    const [lang, setLang] = useState(i18n.language || 'zh');

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        setLang(lng);
    };

    return (
        <div className="App relative">
            <div className="absolute top-4 right-4 z-50 flex">
                <button
                    className={`px-3 py-1 rounded-l border border-blue-500 ${lang === 'zh' ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'}`}
                    onClick={() => changeLanguage('zh')}
                >
                    中文
                </button>
                <button
                    className={`px-3 py-1 rounded-r border border-blue-500 ${lang === 'en' ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'}`}
                    onClick={() => changeLanguage('en')}
                >
                    English
                </button>
            </div>
            <IncomeCalculator />
        </div>
    );
}

export default App;